const cellWidth = require("text-width");
import React, { useState } from "react";
import DogEar from "./DogEar.jsx";
import extremeDataValue from "../../../../../Utils/ExtremeDataValue.js";
import ThemeHelper from "ThemeHelper";
import numeral from "numeral";

const DataRowCell = ({
  cellItem,
  cellIndex,
  rowIndex,
  metricsName,
  xAxis,
  xpoint,
  cWidth,
  rowHeight,
  isSelected,
  isAIEnabled,
  showDogEar,
  dogEarText,
  handleCellClick,
  isWithIndex,
}) => {
  const [isHover, setIsHover] = useState(false);
  const getDecimalPlaces = (decimal) => {
    let returnValue = "0.";
    for (let index = 0; index < decimal; index++) {
      returnValue += "0";
    }
    return returnValue;
  };
  const paddingText = 3.5;
  let cellValue = cellItem.Value;
  let textWidth = cellWidth(cellItem.Value, { family: "calibri", size: 12 });

  if (cellItem.header?.IsPerc) {
    const val = cellItem.ActualValue > 0 ? `+${cellValue}%` : `${cellValue}%`;
    textWidth = cellWidth(val, { family: "calibri", size: 12 });
  }

  const textW = Math.round(textWidth);
  const shouldAbbreviate = textW + paddingText >= cWidth;

  if (shouldAbbreviate) {
    if (cellItem.IsActual) {
      if (cellItem.header.IsPerc) {
        cellValue = `${numeral(cellValue?.replace(/%/, ""))
          .format(`${getDecimalPlaces(cellItem.header.DigitAfterDecimals)}a`)
          .toUpperCase()}%`;
        cellValue = cellItem.ActualValue > 0 ? `+${cellValue}` : cellValue;
      } else {
        if (cellItem.isPE) {
          cellValue = `${extremeDataValue.abbreviateValue(
            cellItem.LowValue,
            0,
            "",
            true
          )}-
          ${extremeDataValue.abbreviateValue(cellItem.HighValue, 0, "", true)}`;
        } else {
          cellValue = numeral(cellValue)
            .format(`${getDecimalPlaces(cellItem.header.DigitAfterDecimals)}a`)
            .toUpperCase();
        }
      }
    } else if (!cellItem.IsActual) {
      if (cellItem.header.IsPerc) {
        cellValue = `${numeral(cellValue?.replace(/%/, ""))
          .format(`${getDecimalPlaces(cellItem.header.DigitAfterDecimals)}a`)
          .toUpperCase()}%e`;
        cellValue = cellItem.ActualValue > 0 ? `+${cellValue}` : cellValue;
      } else {
        if (cellItem.isPE) {
          cellValue = `${extremeDataValue.abbreviateValue(
            cellItem.LowValue,
            0,
            "",
            true
          )}e-
          ${extremeDataValue.abbreviateValue(
            cellItem.HighValue,
            0,
            "",
            true
          )}e`;
        } else {
          cellValue = `${numeral(cellValue)
            .format(
              `${getDecimalPlaces(cellItem.header.DigitAfterDecimals)}a`,
              "",
              true
            )
            .toUpperCase()}e`;
        }
      }
    }
  }

  let textColor = "";
  if (cellItem.IsPositive)
    textColor = ThemeHelper.getThemedBrush("positiveDataText");
  else if (cellItem.IsPositive === false)
    textColor = ThemeHelper.getThemedBrush("negativeDataText");

  const cellKey = `financial_cell_${metricsName}_${cellIndex}_${rowIndex}`;
  const showDogEarPolygon = cellItem.DogEarContent && isWithIndex;

  return (
    <>
      <g
        id={cellKey}
        key={cellKey}
        onClick={() => {
          if (isAIEnabled) {
            handleCellClick(cellIndex, metricsName);
          }
        }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <rect
          id={cellItem.Value ? "financial_metric_rect" : "financial_empty_rect"}
          x={xAxis - cWidth + paddingText}
          y={0}
          width={cWidth}
          height={rowHeight}
          fill="transparent"
          stroke={isSelected ? "red" : (isHover && isAIEnabled)? ThemeHelper.getThemedBrush("finAIEmptyDot") : "none"}
          strokeWidth={isSelected || (isHover && isAIEnabled) ? 1 : 0}
          style={{ cursor: isAIEnabled ? "pointer" : "" }}
        />
        <text
          className={cellItem.className}
          style={{
            textAnchor: "end",
            fill: cellItem.Value
              ? textColor
              : ThemeHelper.getThemedBrush("finAIEmptyDot"),
            cursor: isAIEnabled ? "pointer" : "",
            fontSize: cellItem.Value ? undefined : "16px",
          }}
          x={xAxis}
          y={rowHeight - 3}
        >
          {cellItem.Value ? cellValue : isAIEnabled ? "." : ""}
        </text>
      </g>
      {showDogEarPolygon && (
        <DogEar
          isHover={isHover}
          onShowDogEar={(dogEar) => showDogEar(dogEar)}
          height={rowHeight - 2}
          text={dogEarText}
          width={cWidth}
          x={xpoint}
          key={`dogEar${cellIndex}`}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        />
      )}
    </>
  );
};

export default DataRowCell;
